import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	consultarTipoModificacaoAlteracaoSuccess,
	consultarTipoModificacaoAlteracaoFailure,
} from './actions';

function* consultarTipoModificacaoAlteracaoRequest(request: ReducerAction) {
	const { payload }: { payload: string } = request;

	const response: ApiResponse = yield call(
		getApi,
		PATH_DETRAN_CRV,
		`consultas/${CHANNEL}/consultar-tipo-modificacao-alteracao/${payload}`,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarTipoModificacaoAlteracaoSuccess(response.data));
	} else if (response.error) {
		yield put(consultarTipoModificacaoAlteracaoFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_TIPO_MODIFICACAO_ALTERACAO_REQUEST,
		consultarTipoModificacaoAlteracaoRequest,
	),
]);
